module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eu-player"
  }, [_c('div', {
    staticClass: "eu-player-canvas",
    attrs: {
      "id": _vm.containerId
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "eu-player-loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._e(), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "eu-player-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bad1a3e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player/EuPlayer.vue
// module id = 399
// module chunks = 0